import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    listNumbered: { id: 'lblIconListNumbered', defaultMessage: 'Numbered list' },
});

const ListNumberedIcon = React.memo(function ListNumberedIcon(props: TListNumberedIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.listNumbered)} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.234 3.281h-.89a.094.094 0 0 1-.094-.094v-.843c0-.052.042-.094.094-.094h1.828c.103 0 .187.084.187.188v3.656a.094.094 0 0 1-.093.093h-.938a.094.094 0 0 1-.094-.093V3.28Zm-.89 12.281h2.719c.051 0 .093.043.093.094v3.75a.094.094 0 0 1-.093.094h-2.72a.094.094 0 0 1-.093-.094v-.797c0-.051.042-.093.094-.093H4.04v-.504h-.837a.094.094 0 0 1-.094-.094v-.797c0-.051.042-.094.094-.094h.837v-.48H2.344a.094.094 0 0 1-.094-.094v-.797c0-.051.042-.094.094-.094Zm2.719-6.656h-2.72A.094.094 0 0 0 2.25 9v.844c0 .051.042.094.094.094h1.603l-1.648 1.82a.194.194 0 0 0-.049.127v.865c0 .052.042.094.094.094h2.719a.094.094 0 0 0 .093-.094v-.844a.094.094 0 0 0-.093-.094H3.458l1.648-1.82a.195.195 0 0 0 .05-.127V9a.094.094 0 0 0-.095-.094ZM8 4a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-.5A.5.5 0 0 0 18 4H8Zm-.5 6.75a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-.5ZM8 16.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V17a.5.5 0 0 0-.5-.5H8Z"
            />
        </IconBase>
    );
});

export default ListNumberedIcon;

// #region Types

export type TListNumberedIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function'
        ? () => <ListNumberedIcon />
        : { ...IconBaseExample, render: ListNumberedIcon };

// #endregion
